export default {
      id: "ic_plus-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#ic_plus",
      toString: function () {
        return this.url;
      }
    }